import { useEffect, useState } from 'react';
import { getFetchErrors } from '@/utils/getFetchErrorMessage';
import { FetchErrorsType } from '@/types/types/general/errors';

export const useExtractedFetchErrorMessage = (error: unknown) => {
    const [errorMessage, setErrorMessage] = useState<FetchErrorsType>();

    useEffect(() => {
        setErrorMessage(getFetchErrors(error));
    }, [error]);

    return errorMessage;
};
